"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../../Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DropDownIcon = function DropDownIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-dropdown-icon"),
    width: "7",
    height: "6",
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.50279 3.80036L6.14777 1.14605C6.19402 1.09935 6.24908 1.06228 6.30975 1.03698C6.37042 1.01168 6.4355 0.998657 6.50123 0.998657C6.56696 0.998657 6.63204 1.01168 6.69271 1.03698C6.75338 1.06228 6.80844 1.09935 6.85469 1.14605C6.9478 1.2404 7 1.36763 7 1.50018C7 1.63274 6.9478 1.75996 6.85469 1.85431L3.85625 4.85542C3.76532 4.94621 3.64287 4.99841 3.5144 5.00114C3.38594 5.00387 3.26137 4.95693 3.16666 4.87009L0.146882 1.85698C0.0529604 1.76324 0.000125408 1.63602 4.76837e-07 1.50332C-0.000124454 1.37062 0.0524702 1.24331 0.146214 1.14939C0.239959 1.05546 0.367175 1.00263 0.499874 1.0025C0.632574 1.00238 0.759889 1.05497 0.85381 1.14872L3.50279 3.80036Z",
    fill: "#B1B2B3"
  }));
};
var _default = DropDownIcon;
exports.default = _default;